<template>
  <v-container class="widget-screen">
    <dash-header
      :date-range="$store.state.Dashboard.dateRange"
      theme-header="Conversion"
      :views="viewTypes"
      v-on:date-range-changed="triggerUpdates"
      v-on:range-config-updated="triggerUpdates"
      :bus="bus"
      class="widget-header-container"
    ></dash-header>

    <v-layout>
      <!--  align-start justify-center row -->
      <v-flex xs9 class="widgetPaddingLeft">
        <excel-download-button view="conversion"></excel-download-button>
        <v-tabs
          v-model="active"
          dark
          slider-color="yellow"
          icons-and-text
          class="widgetTabs"
        >
          <v-tab
            key="count"
            ripple
            @click="tabClicked"
          >

            <table>
              <tr>
                <td colspan="2"><p class="tabTitle"><strong>Conversion by Count</strong></p></td>
              </tr>
              <tr>
                <td colspan="2"><h2>{{ totalCount }}</h2></td>
              </tr>
              <tr >
                <td class="totalCountConverted" style="color: blue !important;">{{ totalCountConverted }} <i class="material-icons">check_circle</i></td>
                <td class="totalCountUnconverted" style="color: red !important;">{{ totalCountUnconverted }} <i class="material-icons">cancel</i></td>
              </tr>
            </table>
            <!--<h3>Conversion by Count</h3>
            <h1>{{ totalCount }}</h1>-->
          </v-tab>
          <v-tab
            key="value"
            ripple
            @click="tabClicked"
          >
            <!--<h3>Conversion by Value</h3>
            <h1>R{{ totalValue }}</h1>-->
            <table>
              <tr>
                <td colspan="2"><p class="tabTitle"><strong>Conversion by Value</strong></p></td>
              </tr>
              <tr>
                <td colspan="2"><h2>R{{ totalValue }}</h2></td>
              </tr>
              <tr >
                <td class="totalValueConverted" style="color: blue !important;">R{{ totalValueConverted }} <i class="material-icons">check_circle</i></td>
                <td class="totalValueUnconverted" style="color: red !important;">R{{ totalValueUnconverted }} <i class="material-icons">cancel</i></td>
              </tr>
            </table>
          </v-tab>
          <v-tab
            key="percentage"
            ripple
            @click="tabClicked"
          >
            <table>
              <tr>
                <td><p class="tabTitle"><strong>Conversion % by Count</strong></p></td>
              </tr>
              <tr>
                <td><h2>{{ totalPercent }}</h2></td>
              </tr>
            </table>
            <!--<h3>Conversion by Percentage</h3>
            <h1>{{ totalPercent }}</h1>-->
          </v-tab>
          <v-tab
            key="percentageByValue"
            ripple
            @click="tabClicked"
          >
            <table>
              <tr>
                <td><p class="tabTitle"><strong>Conversion % by Value</strong></p></td>
              </tr>
              <tr>
                <td><h2>{{ totalValuePercent }}</h2></td>
              </tr>
            </table>
            <!--<h3>Conversion by Percentage</h3>
            <h1>{{ totalPercent }}</h1>-->
          </v-tab>
          <v-tab-item
            key="count"
            :lazy="true"
          >
            <v-card class="justify-center align-center svg-container" style="text-align: center; height: 550px; padding-left: 25px;">
              <conversion-count
                :view-data="dataView.count"
                :date-range="$route.params.dateRange"
                :updateData="updateComponents"
                v-on:widgets-updated="resetTrigger"
                v-on:conversion-bar-selected="updateViewByBarSelection"
                :bus="bus"
                v-if="!loading"
              ></conversion-count>
              <img class="imgLoader" src="../../../shared/assets/images/3dloader.gif" v-else   />
            </v-card>
          </v-tab-item>
          <v-tab-item
            key="value"
            :lazy="true"
          >
            <v-card class="justify-center align-center svg-container" style="text-align: center">
              <conversion-value
                :view-data="dataView.value"
                :date-range="$route.params.dateRange"
                :updateData="updateComponents"
                :bus="bus"
                v-on:conversion-bar-selected="updateViewByBarSelection"
                v-if="!loading"
              ></conversion-value>
              <img class="imgLoader" src="../../../shared/assets/images/3dloader.gif" v-else  />
            </v-card>
          </v-tab-item>
          <v-tab-item
            key="percentage"
            :lazy="true"
          >
            <v-card class="justify-center align-center svg-container" style="text-align: center">
              <conversion-percentage
                :view-data="dataView.percent"
                :date-range="$route.params.dateRange"
                :updateData="updateComponents"
                :bus="bus"
                v-on:conversion-bar-selected="updateViewByBarSelection"
                v-if="!loading"
              ></conversion-percentage>
              <img class="imgLoader" src="../../../shared/assets/images/3dloader.gif" v-else  />
            </v-card>
          </v-tab-item>
          <v-tab-item
            key="percentageByValue"
            :lazy="true"
          >
            <v-card class="justify-center align-center svg-container" style="text-align: center">
              <conversion-percentage
                :view-data="dataView.percentByValue"
                :date-range="$route.params.dateRange"
                :updateData="updateComponents"
                :bus="bus"
                v-on:conversion-bar-selected="updateViewByBarSelection"
                v-if="!loading"
              ></conversion-percentage>
              <img class="imgLoader" src="../../../shared/assets/images/3dloader.gif" v-else  />
            </v-card>
          </v-tab-item>
        </v-tabs>
        <div class="chart-disclaimer" v-if="this.$store.state.Dashboard.widgetConfig.viewType === 'date_range' && this.loading === false"><small>Based on Quote Origination date</small></div>
      </v-flex>
      <v-flex xs3 class="widgetPaddingRight">
        <filters v-on:apply-filters="setFilters" :bus="bus" :filters="filters"></filters>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DashHeader from "../../elements/DashHeader";
import ConversionCount from "./widgets/ConversionCount";
import ConversionValue from "./widgets/ConversionValue";
import ConversionPercentage from "./widgets/ConversionPercentage";
import Vue from "vue";
import moment from "moment";
import Filters from "../../elements/Filters";
import ExcelDownloadButton from "../../elements/ExcelDownloadButton";
import qs from 'qs';

export default {
  name: "ConversionSection",
  data() {
    return {
      abortController: null,
      viewTypes: {
        label: 'By Date',
        action: () => {
          this.$emit('collate-by-date');
        }
      },
      loading: false,
      filters: [],
      config: {},
      active: null,
      updateComponents: false,
      tabTotals: {
        total: 0,
        value: 0,
        sales_total: 0,
        sales_value: 0
      },
      dataView: {
        count: [],
        value: [],
        percent: [],
        percentByValue: []
      },
      bus: new Vue()
    }
  },
  methods: {
    fetchData() {
      if (this.abortController)
        this.abortController.abort('The previous request was interrupted.');

      this.abortController = new AbortController;

      console.log('Fetching Conversion data');

      this.loading = true;

      return this.$axios.get(window.location.protocol + process.env.API_ENDPOINT + 'Widget.php', {
        signal: this.abortController.signal,
        params: {
          a: 'conversion_py',
          token: 'dlBWlbFDgR5A0eearsSZBouOH9I9282I',
          params: {
            manufacturer: this.$store.getters.objAuthorize.manufacturer,
            date_from: this.$store.state.Dashboard.widgetConfig.dateRange.from.length !== 0 ? this.$store.state.Dashboard.widgetConfig.dateRange.from : moment().subtract(3, 'months').format('YYYY-MM-DD'), //this.dateRange.from,
            date_to: this.$store.state.Dashboard.widgetConfig.dateRange.to.length !== 0 ? this.$store.state.Dashboard.widgetConfig.dateRange.to : moment().endOf('day').format('YYYY-MM-DD'), //this.dateRange.to,
            metric: 'count',
            view: this.$store.state.Dashboard.widgetConfig.viewType,
            reporting_increment: this.$store.state.Dashboard.widgetConfig.periodType,
            filters: this.$store.state.Dashboard.widgetConfig.filters,
            userId: this.$store.getters.objAuthorize.id
          }
        },
        paramsSerializer: params => {
          return qs.stringify(params);
        }
      }).then((response) => {
        this.loading = false;
        const recordSet = response.data;
        this.dataView = recordSet.data;
        this.tabTotals = recordSet.totals;
        recordSet.filters.quote_types = [
          {id: 'service_form', name: 'Service Form'},
          {id: 'calculator', name: 'Calculator'},
          {id: 'installation_ls', name: 'Installation Look-up Service'},
        ];

        this.filters = recordSet.filters;
      }).catch((err) => {
        this.loading = false;
        if (err.constructor.name === 'Cancel') {
          console.log('Request cancelled: ', err.message);
        } else {
          console.log('An error occurred: ' + err.toString(), err);
        }
      }).finally(() => {
        this.loading = false;
        this.abortController = null;
      });
    },
    triggerUpdates() {
      this.fetchData();
    },
    resetTrigger() {
      this.updateComponents = false;
    },
    nFormatter(num, digits) {
      // const lookup = [
      //   { value: 1, symbol: "" },
      //   { value: 1e3, symbol: "k" },
      //   { value: 1e6, symbol: "m" },
      //   { value: 1e9, symbol: "b" },
      //   { value: 1e12, symbol: "t" },
      //   { value: 1e15, symbol: "p" },
      //   { value: 1e18, symbol: "e" }
      // ];
      // const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
      // const item = lookup.slice().reverse().find(function(item) {
      //   return num >= item.value;
      // });
      // return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
      return num ? parseFloat(num).toLocaleString() : "0";
    },
    setFilters(event) {
      console.log('Filters Applied in Conversions', event);
      this.triggerUpdates();
    },
    updateViewByBarSelection(event) {
      this.bus.$emit('trigger-view-update', event);
      this.bus.$emit('bar-clicked', event);
    },
    tabClicked() {
      this.bus.$emit('tab-changed');
    }
  },
  components: {ExcelDownloadButton, Filters, ConversionPercentage, ConversionValue, ConversionCount, DashHeader},
  computed: {
    totalCount: function() {
      /*const val = parseInt(this.tabTotals.sales_total);
      return this.nFormatter(val, 1);*/
      const val = parseInt(this.tabTotals.total);
      return this.nFormatter(val, 1);
    },
    totalCountConverted: function() {
      const val = parseInt(this.tabTotals.sales_total);
      return this.nFormatter(val, 1);
    },
    totalCountUnconverted: function() {
      const total = parseInt(this.tabTotals.total);
      const sales = parseInt(this.tabTotals.sales_total);
      const val = total - sales;
      return this.nFormatter(val, 1);
    },
    totalValue: function() {
      /*const val = parseInt(this.tabTotals.sales_value);
      return this.nFormatter(val, 1);*/
      const val = parseInt(this.tabTotals.value);
      return this.nFormatter(val, 1);
    },
    totalValueConverted: function() {
      const val = parseInt(this.tabTotals.sales_value);
      return this.nFormatter(val, 1);
    },
    totalValueUnconverted: function() {
      const total = parseInt(this.tabTotals.value);
      const sales = parseInt(this.tabTotals.sales_value);
      const val = total - sales;
      return this.nFormatter(val, 1);
    },
    totalPercent: function() {
      const valTotal = parseInt(this.tabTotals.total);
      const valSales = parseInt(this.tabTotals.sales_total);
      const percent = ((valSales / valTotal) * 100).toFixed(0);

      const percentString = percent !== "NaN" ? percent : "0";

      return percentString + '%';
    },
    totalValuePercent: function() {
      const valTotal = parseInt(this.tabTotals.value);
      const valSales = parseInt(this.tabTotals.sales_value);
      const percent = ((valSales / valTotal) * 100).toFixed(0);

      const percentString = percent !== "NaN" ? percent : "0";

      return percentString + '%';
    }
  },
  beforeCreate() {
    if (localStorage.getItem('widgetConfig')) {
      const config = JSON.parse(localStorage.getItem('widgetConfig'));
      this.$store.commit('setWidgetConfig', config);
    }
  },
  created() {
    this.bus.$on('trigger-theme-changed', () => {
      if (this.abortController)
        this.abortController.abort();
    });
    this.$store.subscribe((mutation, state) => {
      localStorage.setItem('widgetConfig', JSON.stringify(this.$store.state.Dashboard.widgetConfig));
    })
    this.fetchData();
    this.$store.state.Dashboard.widgetConfig.theme = 'conversion';
  }
}
</script>

<style scoped>
  .chart-disclaimer {
    position: relative;
    top: 10px;
    z-index: 9999;
    text-align: center;
    display: block;
  }
  .svg-container {
    padding: 20px;
  }
</style>
